import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthGuard, Logger, LoggerService } from '@shared/utils';
import { filter, map, Subject, switchMap, take } from 'rxjs';

@Component({
  selector: 'reza-login',
  standalone: true,
  imports: [CommonModule],
  template: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent implements OnInit {
  readonly loggerService = inject(LoggerService);
  private logger: Logger = this.loggerService.createLogger('LoginComponent');
  doneSub$ = new Subject<boolean>();
  done$ = this.doneSub$.pipe(take(1), filter(Boolean));
  hack = false;

  authGuard = inject(AuthGuard);
  route = inject(ActivatedRoute);
  router = inject(Router);

  ngOnInit(): void {
    this.authGuard.authStatusDone$.subscribe((result) => {
      this.logger.info('LoginComponent.authGuard.authStatusDone$', result);
      if (result) {
        // Uživatel je již přihlášen, takže naviguje na hlavní stránku.
        this.router.navigate(['/']);
      }
    });

    this.route.queryParams
      .pipe(
        map((params) => params['hack'] === 'true'), // Convert the 'hack' parameter to a boolean
        switchMap((hack) => {
          this.hack = hack;
          // return this.authService.login(this.hack); //
          return this.authGuard.canActivate();
        })
      )
      .subscribe((result) => {
        this.logger.info('login.result', result);
        this.logger.info(result ? 'Login successful' : 'Login failed');
        // this.doneSub$.next(true);
      });
  }
}
